import axios from 'axios';
import tenant from "@/helper/tenant";

class HttpClient {
    constructor(options = {}) {
        this.instance = axios.create(options)
    }

    async get(apiPath, params = {}, headers = {}) {
        if (tenant.has()) headers.tenant = tenant.get();
        headers.token = localStorage.getItem('token');
        return axios({url: apiPath, method: 'GET', params: params, headers: headers});
    }

    async post(apiPath, params = {}, headers = {}) {
        if (tenant.has()) headers.tenant = tenant.get();
        headers.token = localStorage.getItem('token');
        return this.instance.post(apiPath, params, {headers: headers});
    }

    async put(apiPath, params = {}, headers = {}) {
        if (tenant.has()) headers.tenant = tenant.get();
        headers.token = localStorage.getItem('token');
        return this.instance.put(apiPath, params, {headers: headers});
    }

    async delete(apiPath, headers = {}) {
        if (tenant.has()) headers.tenant = tenant.get();
        headers.token = localStorage.getItem('token');
        return this.instance.delete(apiPath, {headers: headers});
    }

    async getForeign(apiPath) {
        return this.instance.get(apiPath);
    }
}

export default HttpClient;